import { useMemo } from 'react';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

import { useBreadcrumbProxyServersQuery } from '../../ProxyServers';
import { DynamicBreadcrumbWrapper } from './DynamicBreadcrumbWrapper';

const DynamicProxyServersByIdBreadcrumb: BreadcrumbComponentType<'proxyServerId'> = ({ match }) => {
  const proxyServerId = useMemo(() => match.params.proxyServerId ?? '', [match.params.proxyServerId]);

  const breadcrumbQuery = useBreadcrumbProxyServersQuery(proxyServerId)();

  return <DynamicBreadcrumbWrapper { ...breadcrumbQuery }/>;
};

const DynamicProxyServersListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Проксі-сервери</span>;
};

export const DynamicProxyServersBreadcrumb = {
  DynamicProxyServersListBreadcrumb,
  DynamicProxyServersByIdBreadcrumb
};
